import React from 'react';
import { Link } from 'react-router-dom';
import SEO from '../components/SEO';

const TermsPage = () => {
  const seoData = {
    title: 'Terms and Conditions | CTHomeRemodels.com',
    description: 'Terms and conditions for using CTHomeRemodels.com and Visser General Construction LLC services.',
    canonical: 'https://cthomeremodels.com/terms'
  };

  return (
    <div className="terms-page">
      <SEO {...seoData} />
      
      <section className="bg-[#5c0701] text-white py-16">
        <div className="container mx-auto px-4 text-center">
          <h1 className="text-4xl md:text-5xl font-bold mb-4">Terms and Conditions</h1>
          <p className="text-xl">Last Updated: March 6, 2026</p>
        </div>
      </section>

      <section className="py-16">
        <div className="container mx-auto px-4 max-w-4xl">
          <div className="bg-white rounded-xl shadow-lg p-8 space-y-6">
            <div>
              <h2 className="text-2xl font-bold mb-4">1. Acceptance of Terms</h2>
              <p className="text-gray-700 leading-relaxed">
                By accessing and using CTHomeRemodels.com (the "Website"), you accept and agree to be bound by these Terms and Conditions. If you do not agree to these terms, please do not use our Website or services.
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-bold mb-4">2. Services</h2>
              <p className="text-gray-700 leading-relaxed mb-4">
                Visser General Construction LLC provides home remodeling and construction services in Connecticut. Our services include but are not limited to:
              </p>
              <ul className="list-disc list-inside text-gray-700 space-y-2 ml-4">
                <li>Kitchen remodeling</li>
                <li>Bathroom remodeling</li>
                <li>Trex decking installation</li>
                <li>Basement finishing</li>
                <li>Vinyl siding</li>
                <li>Window replacement</li>
                <li>Custom furniture</li>
                <li>General home maintenance</li>
              </ul>
            </div>

            <div>
              <h2 className="text-2xl font-bold mb-4">3. Quotes and Estimates</h2>
              <p className="text-gray-700 leading-relaxed">
                All quotes and estimates provided are for informational purposes and are subject to change based on site inspection, material costs, and project scope. Final pricing will be confirmed in writing before work begins.
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-bold mb-4">4. SMS and Email Communications</h2>
              <p className="text-gray-700 leading-relaxed">
                By providing your phone number or email address, you consent to receive communications from Visser General Construction LLC regarding your inquiry, project updates, and service-related information. You may opt out at any time by replying STOP to text messages or clicking unsubscribe in emails.
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-bold mb-4">5. Intellectual Property</h2>
              <p className="text-gray-700 leading-relaxed">
                All content on this Website, including text, images, logos, and design, is the property of Visser General Construction LLC and is protected by copyright laws. Unauthorized use is prohibited.
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-bold mb-4">6. Limitation of Liability</h2>
              <p className="text-gray-700 leading-relaxed">
                Visser General Construction LLC shall not be liable for any indirect, incidental, or consequential damages arising from the use of this Website or our services, except as required by law.
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-bold mb-4">7. Changes to Terms</h2>
              <p className="text-gray-700 leading-relaxed">
                We reserve the right to modify these Terms and Conditions at any time. Changes will be posted on this page with an updated revision date.
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-bold mb-4">8. Contact Information</h2>
              <p className="text-gray-700 leading-relaxed">
                For questions about these Terms and Conditions, please contact us:
              </p>
              <div className="mt-4 p-4 bg-gray-50 rounded-lg">
                <p className="font-medium">Visser General Construction LLC</p>
                <p className="text-gray-700">42 Gay St, Meriden, CT</p>
                <p className="text-gray-700">Phone: (203) 604-3202</p>
                <p className="text-gray-700">Email: codyvisser5@gmail.com</p>
              </div>
            </div>

            <div className="pt-6 border-t">
              <Link
                to="/"
                className="text-blue-600 hover:underline font-medium"
              >
                ← Back to Home
              </Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default TermsPage;